import React, { useState } from "react";
import "./election-brick-wall.m.css";

import Separator from "../../atoms/separator";

import DownArrow from "../../atoms/other-icons/DownArrow";

const ElectionBrickWall = ({
  stateName = "RAJASTHAN",
  showStateTabs = false,
  electionSlugData,
  electionData,
  year,
  showSeperator = true
}) => {
  const [activeState, setActiveState] = useState(stateName);
  const [constituencyData, setConstituencyData] = useState(electionData?.[activeState]);
  const [openDropdown, setDropdownOpen] = useState(false);
  const [loadMoreOpen, setLoadMoreOpen] = useState(false);

  const onStateClick = (state) => {
    setActiveState(state);
    setConstituencyData(electionData?.[state]);
    setLoadMoreOpen(false);
  };

  //ignoring last index as it has election landing page details
  const newSlugArray = electionSlugData.slice(0, -1);

  return (
    <div styleName="wrapper">
      <div styleName="title-pipe"></div>
      <div styleName="brick-wall-heading">
        ASSEMBLY ELECTIONS {activeState} {year} | CONSTITUENCY-WISE RESULTS
      </div>
      {newSlugArray.length > 0 && showStateTabs && (
        <>
          <div styleName="tabs-wrapper" className="hide-mobile">
            {newSlugArray.map((stateData) => (
              <div
                styleName={`state-tab ${activeState === stateData?.state ? "active-tab" : ""}`}
                onClick={() => {
                  onStateClick(stateData?.state);
                }}
                key={stateData?.slug}
              >
                {stateData?.state}
              </div>
            ))}
          </div>
          <div styleName="tabs-mobile-wrapper" className="hide-desktop">
            <div
              styleName="selected-tab-wrapper"
              onClick={() => {
                setDropdownOpen(!openDropdown);
              }}
            >
              <span>{activeState}</span>
              <DownArrow color="black" height="10px" width="10px" />
            </div>
            {openDropdown && (
              <div styleName="dropdown-wrapper">
                {newSlugArray.map((stateData) => (
                  <div
                    styleName={`dropdown-tab ${activeState === stateData?.state ? "dropdown-active-tab" : ""}`}
                    onClick={() => {
                      onStateClick(stateData?.state);
                      setDropdownOpen(!openDropdown);
                    }}
                  >
                    {stateData?.state}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
      <div styleName={`constituency-wrapper ${loadMoreOpen ? "" : "keep-clamp"}`}>
        {constituencyData.map((constituency, index) => (
          <>
            {/* {index !== 0 && <span styleName="pipe-symbol">|</span>} */}
            <a styleName="constituency-name" href={constituency?.publishedUrl}>
              {constituency?.constituencyName}
            </a>
          </>
        ))}
        {!loadMoreOpen && (
          <span
            onClick={() => {
              setLoadMoreOpen(true);
            }}
            styleName="load-more-button-wrapper"
          >
            <span styleName="load-more-button">Load More</span>
          </span>
        )}
      </div>
      <div styleName="state-name-wrapper">
        <span styleName="state-menu-title">Assembly Elections {year}</span> |{" "}
        {newSlugArray.length > 0 &&
          newSlugArray.map((stateData) => (
            <>
              <a styleName="state-menu-item" href={`/${stateData?.slug}`}>
                {stateData?.state}
              </a>
              <span styleName="pipe-symbol">|</span>
            </>
          ))}
      </div>
      {showSeperator && <Separator />}
    </div>
  );
};

export default ElectionBrickWall;
